import { Slide } from "react-reveal";

const SolutionItemHero = (props) => {
  return (
    <section className="section-spacing-80 solution-item-hero">
      <div className="container">
        <div className="large">
          <div className="section-content-container"> 
            <div className="solution-item-hero-content">
              <span className="solution-item-tag">Solution</span>
              <h1 className="solution-item-title">{props.title}</h1>
              <p className="solution-item-subtitle">{props.subtitle}</p>
              <div className="hero-cta-container flex">
                <Slide bottom>
                  <a
                    href={props.mainCTAlink}
                    className="button main-cta hero-cta"
                  >
                    {props.CTAtext}
                  </a>
                </Slide>
                <Slide bottom>
                  <a
                    href={props.casestudylink}
                    className="button sub-cta hero-cta"
                  >
                    Case Studies
                  </a>
                </Slide>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SolutionItemHero;
